export async function openLatestDeliveryCache() {
    const cacheNames = await caches.keys();

    // Filter caches that start with 'delivery-contents'
    const deliveryCaches = cacheNames.filter(name =>
        name.startsWith('delivery-contents-')
    );

    if (deliveryCaches.length === 0) return null;

    // Sort by date and version
    deliveryCaches.sort((a, b) => {
        // Extract date and v-number from names like 'delivery-contents-2026-03-20-v3'
        const regex = /^delivery-contents-(\d{4}-\d{2}-\d{2})-v(\d+)$/;

        const [, dateA, verA] = a.match(regex) || [];
        const [, dateB, verB] = b.match(regex) || [];

        if (!dateA || !dateB) return 0; // fallback

        // Compare dates first
        const diff = new Date(dateA).getTime() - new Date(dateB).getTime();
        if (diff !== 0) return diff;

        // If same date, compare version numbers
        return parseInt(verA) - parseInt(verB);
    });

    // The latest cache is the last one after sorting
    const latestCacheName = deliveryCaches[deliveryCaches.length - 1];
    return caches.open(latestCacheName);
}


